/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { SecurityRoleFunction } from '../model/securityRoleFunction';
import { SecurityRoleFunctionCreateRequest } from '../model/securityRoleFunctionCreateRequest';
import { SecurityRoleFunctionKeys } from '../model/securityRoleFunctionKeys';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class SecurityRoleToFunctionMappingService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createSecurityRoleFunction
     * Creates a new security role to function mapping that is identified by security role name and security function name.
     * @param securityRoleFunctionCreateRequest the information needed to create a security role to function mapping
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public securityRoleToFunctionMappingCreateSecurityRoleFunction(securityRoleFunctionCreateRequest: SecurityRoleFunctionCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<SecurityRoleFunction>;
    public securityRoleToFunctionMappingCreateSecurityRoleFunction(securityRoleFunctionCreateRequest: SecurityRoleFunctionCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SecurityRoleFunction>>;
    public securityRoleToFunctionMappingCreateSecurityRoleFunction(securityRoleFunctionCreateRequest: SecurityRoleFunctionCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SecurityRoleFunction>>;
    public securityRoleToFunctionMappingCreateSecurityRoleFunction(securityRoleFunctionCreateRequest: SecurityRoleFunctionCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (securityRoleFunctionCreateRequest === null || securityRoleFunctionCreateRequest === undefined) {
            throw new Error('Required parameter securityRoleFunctionCreateRequest was null or undefined when calling securityRoleToFunctionMappingCreateSecurityRoleFunction.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SecurityRoleFunction>(`${this.configuration.basePath}/securityRoleFunctions`,
            securityRoleFunctionCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteSecurityRoleFunction
     * Deletes an existing security role to function mapping based on the specified parameters.
     * @param securityRoleName the security role name
     * @param securityFunctionName the security function name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public securityRoleToFunctionMappingDeleteSecurityRoleFunction(securityRoleName: string, securityFunctionName: string, observe?: 'body', reportProgress?: boolean): Observable<SecurityRoleFunction>;
    public securityRoleToFunctionMappingDeleteSecurityRoleFunction(securityRoleName: string, securityFunctionName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SecurityRoleFunction>>;
    public securityRoleToFunctionMappingDeleteSecurityRoleFunction(securityRoleName: string, securityFunctionName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SecurityRoleFunction>>;
    public securityRoleToFunctionMappingDeleteSecurityRoleFunction(securityRoleName: string, securityFunctionName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (securityRoleName === null || securityRoleName === undefined) {
            throw new Error('Required parameter securityRoleName was null or undefined when calling securityRoleToFunctionMappingDeleteSecurityRoleFunction.');
        }
        if (securityFunctionName === null || securityFunctionName === undefined) {
            throw new Error('Required parameter securityFunctionName was null or undefined when calling securityRoleToFunctionMappingDeleteSecurityRoleFunction.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<SecurityRoleFunction>(`${this.configuration.basePath}/securityRoleFunctions/securityRoleNames/${encodeURIComponent(String(securityRoleName))}/securityFunctionNames/${encodeURIComponent(String(securityFunctionName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getSecurityRoleFunction
     * Retrieves an existing security role to function mapping based on the specified parameters.
     * @param securityRoleName the security role name
     * @param securityFunctionName the security function name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public securityRoleToFunctionMappingGetSecurityRoleFunction(securityRoleName: string, securityFunctionName: string, observe?: 'body', reportProgress?: boolean): Observable<SecurityRoleFunction>;
    public securityRoleToFunctionMappingGetSecurityRoleFunction(securityRoleName: string, securityFunctionName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SecurityRoleFunction>>;
    public securityRoleToFunctionMappingGetSecurityRoleFunction(securityRoleName: string, securityFunctionName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SecurityRoleFunction>>;
    public securityRoleToFunctionMappingGetSecurityRoleFunction(securityRoleName: string, securityFunctionName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (securityRoleName === null || securityRoleName === undefined) {
            throw new Error('Required parameter securityRoleName was null or undefined when calling securityRoleToFunctionMappingGetSecurityRoleFunction.');
        }
        if (securityFunctionName === null || securityFunctionName === undefined) {
            throw new Error('Required parameter securityFunctionName was null or undefined when calling securityRoleToFunctionMappingGetSecurityRoleFunction.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SecurityRoleFunction>(`${this.configuration.basePath}/securityRoleFunctions/securityRoleNames/${encodeURIComponent(String(securityRoleName))}/securityFunctionNames/${encodeURIComponent(String(securityFunctionName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getSecurityRoleFunctions
     * Retrieves a list of security role to function mapping keys for all security role to function mappings registered in the system. The result list is sorted by security role name and security function name in ascending order.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public securityRoleToFunctionMappingGetSecurityRoleFunctions(observe?: 'body', reportProgress?: boolean): Observable<SecurityRoleFunctionKeys>;
    public securityRoleToFunctionMappingGetSecurityRoleFunctions(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SecurityRoleFunctionKeys>>;
    public securityRoleToFunctionMappingGetSecurityRoleFunctions(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SecurityRoleFunctionKeys>>;
    public securityRoleToFunctionMappingGetSecurityRoleFunctions(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SecurityRoleFunctionKeys>(`${this.configuration.basePath}/securityRoleFunctions`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getSecurityRoleFunctionsBySecurityFunction
     * Retrieves a list of security role to function mapping keys for the specified security function. The result list is sorted by security role name in ascending order.
     * @param securityFunctionName the security function name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public securityRoleToFunctionMappingGetSecurityRoleFunctionsBySecurityFunction(securityFunctionName: string, observe?: 'body', reportProgress?: boolean): Observable<SecurityRoleFunctionKeys>;
    public securityRoleToFunctionMappingGetSecurityRoleFunctionsBySecurityFunction(securityFunctionName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SecurityRoleFunctionKeys>>;
    public securityRoleToFunctionMappingGetSecurityRoleFunctionsBySecurityFunction(securityFunctionName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SecurityRoleFunctionKeys>>;
    public securityRoleToFunctionMappingGetSecurityRoleFunctionsBySecurityFunction(securityFunctionName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (securityFunctionName === null || securityFunctionName === undefined) {
            throw new Error('Required parameter securityFunctionName was null or undefined when calling securityRoleToFunctionMappingGetSecurityRoleFunctionsBySecurityFunction.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SecurityRoleFunctionKeys>(`${this.configuration.basePath}/securityRoleFunctions/securityFunctionNames/${encodeURIComponent(String(securityFunctionName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getSecurityRoleFunctionsBySecurityRole
     * Retrieves a list of security role to function mapping keys for the specified security role. The result list is sorted by security function name in ascending order.
     * @param securityRoleName the security role name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public securityRoleToFunctionMappingGetSecurityRoleFunctionsBySecurityRole(securityRoleName: string, observe?: 'body', reportProgress?: boolean): Observable<SecurityRoleFunctionKeys>;
    public securityRoleToFunctionMappingGetSecurityRoleFunctionsBySecurityRole(securityRoleName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SecurityRoleFunctionKeys>>;
    public securityRoleToFunctionMappingGetSecurityRoleFunctionsBySecurityRole(securityRoleName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SecurityRoleFunctionKeys>>;
    public securityRoleToFunctionMappingGetSecurityRoleFunctionsBySecurityRole(securityRoleName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (securityRoleName === null || securityRoleName === undefined) {
            throw new Error('Required parameter securityRoleName was null or undefined when calling securityRoleToFunctionMappingGetSecurityRoleFunctionsBySecurityRole.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SecurityRoleFunctionKeys>(`${this.configuration.basePath}/securityRoleFunctions/securityRoleNames/${encodeURIComponent(String(securityRoleName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
